import React, { useEffect, useState } from "react";
import { BsArrowLeft } from "react-icons/bs";
import { pendingLogo } from "../../assets/images";

import { useUser } from "../../context/user-context";
import { errorMessage } from "../../utils/errorMessage";
import { API } from "../../constants/api";
import { useMutation } from "@tanstack/react-query";
import toast from "react-hot-toast";
import useAuthAxios from "../../utils/baseAxios";
import ClipLoader from "react-spinners/ClipLoader";
const PhoneCheck = ({
  setOpenPhoneCheck,
  setOpenAddPhone,
  setOpenAddOtp,
  phoneNumber,
  onDismissPhoneVerifyPrompt,
}: any) => {
  const { userDetails } = useUser();
  const firstInitial = userDetails?.user.profile.firstName || "";
  const [disabled, setDisabled] = useState<boolean>(false);
  const axiosInstance = useAuthAxios();

  const handleVerify = async (data: any) => {
    const response = await axiosInstance.post(API.verifyPhone, data);
    return response.data;
  };
  const completeVerify = useMutation({
    mutationFn: handleVerify,
    onSuccess: (r) => {
      toast.success(r.message);
      setTimeout(() => {
        setOpenPhoneCheck(false);
        setOpenAddOtp(true);
      }, 1000);
    },
    onError: (error: any) => {
      toast.error(
        errorMessage((error?.data as any)?.message || String(error?.data))
      );
    },
  });
  const verifyPhone = () => {
    const data = {
      phone_number: phoneNumber,
    };
    completeVerify.mutate(data);
  };
  useEffect(() => {
    if (phoneNumber) {
      setDisabled(false);
    } else {
      setDisabled(true);
    }
  }, [phoneNumber]);

  return (
    <div className="fixed inset-0  flex font-manrope justify-start items-start pt-16 overflow-auto pb-16 bg-[#E7EBEE] dark:bg-primary_dark dark:bg-opacity-95  backdrop-blur-sm">
      <div
        className={` w-11/12 mds:w-8/12 md:7/12 border dark:border-[#303030] bg-white  rounded-xl mx-auto p-6 dark:bg-[#192025]   lgss:w-2/5 xxl:w-1/3 `}
      >
        <div className="w-full flex justify-start gap-6 items-center">
          <button
            type="button"
            onClick={() => {
              onDismissPhoneVerifyPrompt?.();
              setOpenPhoneCheck(false);
            }}
            aria-label="Close"
          >
            <BsArrowLeft className="text-black dark:text-white text-[20px]" />
          </button>
          <h4 className="text-gray-900 dark:text-gray-200 font-sora font-semibold text-[17px]">
            Phone Number Check
          </h4>
        </div>
        <div className="w-full mt-8">
          <div className="w-full flex flex-col gap-6 items-center ">
            <div className="w-[111px] h-[111px] ">
              <img
                src={pendingLogo}
                alt="phoneCheck"
                className="w-full h-full object-cover "
              />
            </div>
            <h4 className="text-gray-900 dark:text-gray-200 font-sora font-bold text-center  w-11/12 text-[24px]">
              {firstInitial}, We want to confirm if {phoneNumber} is your valid
              whatsapp number?
            </h4>
            <h4 className="text-gray-500 text-center font-medium text-[16px] w-10/12">
              A verification code will be sent to this number on{" "}
              <strong className="text-gray-800 dark:text-gray-200">
                Whatsapp
              </strong>
            </h4>
            <div className="w-full flex justify-center items-center mt-24 gap-4">
              <button
                onClick={() => {
                  setOpenAddPhone(true);
                }}
                className="bg-[#D4EBFD] w-1/2  rounded-xl h-[48px] text-secondary_button font-medium"
              >
                Update Phone
              </button>
              <button
                onClick={verifyPhone}
                disabled={disabled}
                className={
                  disabled
                    ? "bg-gray-400 dark:bg-[#8f9294] w-1/2  rounded-xl h-[48px] text-white font-medium"
                    : "bg-secondary_button w-1/2  rounded-xl h-[48px] text-white font-medium"
                }
              >
                {completeVerify.isPending ? (
                  <ClipLoader color="#FFFFFF" size={30} />
                ) : (
                  "Yes, it is"
                )}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PhoneCheck;
